var pkg = {
    name: '@skland/one-bridge',
    version: '1.8.0',
};
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.prototype.log = function (message, level) {
        if (level === void 0) { level = 'info'; }
        var libMessage = "[".concat(pkg.name, ":").concat(pkg.version, "]");
        var logMessage = "[".concat(level.toUpperCase(), "]: ").concat(message);
        switch (level) {
            case 'debug':
                console.debug(logMessage);
                break;
            case 'info':
                console.info(logMessage);
                break;
            case 'warn':
                console.warn(logMessage);
                break;
            case 'error': {
                var error = new Error(logMessage);
                error.name = libMessage;
                console.error(error);
                break;
            }
            default:
                console.log(logMessage);
        }
    };
    Logger.prototype.info = function (message) {
        this.log(message, 'info');
    };
    Logger.prototype.warn = function (message) {
        this.log(message, 'warn');
    };
    Logger.prototype.error = function (message) {
        this.log(message, 'error');
    };
    return Logger;
}());
export default new Logger();
